module.exports = __webpack_public_path__ + "static/media/loyalty-mail-icon.32780b95.png";